<template>
  <div
    v-bind:class="[
      'first-access-content',
      {
        'first-access-content-default': mq.current !== 'mobile',
        'first-access-content-mobile w-screen': mq.current === 'mobile'
      }
    ]"
  >
    <div class="flex w-full flex-row justify-between">
      <div>
        <div class="first_access_content-title">
          <span>{{ $t(`firstAccess.title`) }}</span>
        </div>

        <div>
          <ol class="first_access_content--list">
            <li>
              <span>
                {{
                  $t('firstAccess.topicOne.seeDocumentation')
                }}
                <a
                  class="text-primary font-medium"
                  :href="docURL"
                  target="_blank"
                >
                  {{
                    $t('firstAccess.topicOne.forDevelopers')
                  }} </a
                >.
              </span>
            </li>
            <li>
              <span>
                {{ $t('firstAccess.topicTwo.accessOption') }}
                <a
                  class="text-primary font-medium"
                  :href="createYourApp"
                >
                  {{ $t('firstAccess.topicTwo.createApp') }}
                </a>
                {{ $t('firstAccess.topicTwo.fillInformation') }}
              </span>
            </li>
            <li>
              <span>
                {{
                  $t(
                    'firstAccess.topicThree.developApplicationCode'
                  )
                }}
              </span>
            </li>
            <li>
              <span>
                {{ $t('firstAccess.topicFour.inMenu') }}
                <a
                  class="text-primary font-medium"
                  :href="myAppsURL"
                >
                  {{ $t('firstAccess.topicFour.myApps') }}
                </a>
                {{ $t('firstAccess.topicFour.consultApp') }}
                <span class="font-medium">
                  {{
                    $t(
                      'firstAccess.topicFour.underDevelopment'
                    )
                  }}
                </span>
                {{
                  $t(
                    'firstAccess.topicFour.followDocumentation'
                  )
                }}
              </span>
            </li>
            <li>
              <span>
                {{ $t('firstAccess.topicFive.stillMenu') }}
                <a
                  class="text-primary font-medium"
                  :href="myAppsURL"
                >
                  {{ $t('firstAccess.topicFive.myApps') }}
                </a>
                {{ $t('firstAccess.topicFive.appStatus') }}
              </span>
            </li>
          </ol>
        </div>

        <div class="button">
          <AmButton
            v-bind:label="$t(`firstAccess.button.createApp`)"
            v-bind:size="
              mq.current === 'mobile' ? 'fullWidth' : 'xxlarge'
            "
            variant="maxPrimary"
            @click="router.push({ name: 'create-app' })"
          />
        </div>
      </div>

      <div
        v-if="mq.current !== 'mobile'"
        class="svg">
        <FirstAccessContentSvg class="mt-[40px]" />
      </div>
    </div>
  </div>
</template>

<script setup>
import FirstAccessContentSvg from '@icons/FirstAccessContentSvg.vue'
import { AmButton } from '@appmax_npm/ds-appmax-v3'
import { inject } from 'vue'
import { useRouter } from 'vue-router'

const mq = inject('mq')
const router = useRouter()
const env = inject('env')

const docURL = `${env.app.documentation}`
const myAppsURL = `${env.app.baseURL}/apps`
const createYourApp = `${env.app.baseURL}/app/create/about-app `
</script>

<style lang="scss" scoped>

.first-access-content-default {
    display: flex;
    padding-left: 70px;
    width: 100%;

    .first_access_content {
        &-title {
            margin: 55px 0 40px -20px;
            max-width: 600px;
            font-size: 45px;
            font-family: $secondaryFont;
            color: #333;
        }

        &--list {
            list-style: decimal;
            max-width: 750px;
        
            li {
                margin-bottom: 20px;
                font-family: $primaryFont;
                font-size: 18px;
                color: #5C5C5C;
            }
        
            li::marker {
                font-weight: bold;
            }
        }
    }

    .title {
        margin-top: 55px;
        margin-bottom: 40px;
        max-width: 600px;
    }

    .button {
        display: flex;
        margin-top: 37px;
    }
}

.first-access-content-mobile {
    padding: 34px;

    .first_access_content {
        &-title {
            margin: 16px 0;
            color: #333;
            font-size: 20px;
            width: 100%;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            font-family: $secondaryFont;
        }

        &--list {
            list-style: decimal;
            margin: 0 20px;
        
            li {
                margin-bottom: 10px;
                font-family: $primaryFont;
                font-size: 14px;
                color: #5C5C5C;
            }
        
            li::marker {
                font-weight: bold;
            }
        }
    }

    .title {
        margin-bottom: 22px;
    }

    .button {
        margin-top: 46px;

        .am-button {
            padding: 12px 0;
        }
    }
}
</style>
